module.exports = __webpack_public_path__ + "kudos_62.svg?5d84150e6c1f4f8aff2fab365fe871ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_62.svg
// module id = 164
// module chunks = 0